import { render, staticRenderFns } from "./manage-keywords.html?vue&type=template&id=7af61f7a&scoped=true&"
import script from "./manage-keywords.js?vue&type=script&lang=js&"
export * from "./manage-keywords.js?vue&type=script&lang=js&"
import style0 from "./manage-keywords.scss?vue&type=style&index=0&id=7af61f7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af61f7a",
  null
  
)

export default component.exports